.icons_container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    .entry {
        margin: 5px;
    }
}
